import { events } from "../../js/state-machine";
import { prefix } from "../../design-tokens/meta";

export const componentName = "Breadcrumb";
export const componentClasses = {
    listItem: `${prefix}breadcrumb__item`,
    list: `${prefix}breadcrumb`,
    button: `${prefix}breadcrumb__button`,
    mobileIcon: `${prefix}breadcrumb__mobile-icon`,
};

export const views = {
    breadcrumbList: {
        expanded: {
            attrs: { "aria-expanded": "true" },
        },
        collapsed: {
            attrs: { "aria-expanded": "false" },
        },
    },
    breadcrumbItem: {
        active: {
            attrs: { "aria-current": "page" },
        },
    },
    expandButton: {
        visible: {
            attrs: { "aria-expanded": "false" },
        },
        hidden: {
            attrs: { "aria-expanded": "true" },
        },
    },
};

export const eventMap = {
    expanded: events.expanded(componentName),
    collapsed: events.collapsed(componentName),
};
